// folderDocument
export const FETCH_FOLDER_DOCUMENTS_INIT = "folderDocument@FETCH_FOLDER_DOCUMENTS_INIT"
export const FETCH_FOLDER_DOCUMENTS_SUCCEDED = "folderDocument@FETCH_FOLDER_DOCUMENTS_SUCCEDED"
export const FETCH_FOLDER_DOCUMENTS_FAILED = "folderDocument@FETCH_FOLDER_DOCUMENTS_FAILED"

export const CLEAR_FOLDER_DOCUMENT = "folderDocument@CLEAR_FOLDER_DOCUMENT"

export const CREATE_FOLDER_DOCUMENT_INIT = "folderDocument@CREATE_FOLDER_DOCUMENT_INIT"
export const CREATE_FOLDER_DOCUMENT_SUCCEDED = "folderDocument@CREATE_FOLDER_DOCUMENT_SUCCEDED"
export const CREATE_FOLDER_DOCUMENT_FAILED = "folderDocument@CREATE_FOLDER_DOCUMENT_FAILED"

export const FETCH_FOLDER_DOCUMENT_INIT = "folderDocument@FETCH_FOLDER_DOCUMENT_INIT"
export const FETCH_FOLDER_DOCUMENT_SUCCEDED = "folderDocument@FETCH_FOLDER_DOCUMENT_SUCCEDED"
export const FETCH_FOLDER_DOCUMENT_FAILED = "folderDocument@FETCH_FOLDER_DOCUMENT_FAILED"

export const EDIT_FOLDER_DOCUMENT_INIT = "folderDocument@EDIT_FOLDER_DOCUMENT_INIT"
export const EDIT_FOLDER_DOCUMENT_SUCCEDED = "folderDocument@EDIT_FOLDER_DOCUMENT_SUCCEDED"
export const EDIT_FOLDER_DOCUMENT_FAILED = "folderDocument@EDIT_FOLDER_DOCUMENT_FAILED"

export const DELETE_FOLDER_DOCUMENT_INIT = "folderDocument@DELETE_FOLDER_DOCUMENT_INIT"
export const DELETE_FOLDER_DOCUMENT_SUCCEDED = "folderDocument@DELETE_FOLDER_DOCUMENT_SUCCEDED"
export const DELETE_FOLDER_DOCUMENT_FAILED = "folderDocument@DELETE_FOLDER_DOCUMENT_FAILED"

export const CLOSE_FOLDER_DOCUMENT_INIT = "folderDocument@CLOSE_FOLDER_DOCUMENT_INIT"
export const CLOSE_FOLDER_DOCUMENT_SUCCEDED = "folderDocument@CLOSE_FOLDER_DOCUMENT_SUCCEDED"
export const CLOSE_FOLDER_DOCUMENT_FAILED = "folderDocument@CLOSE_FOLDER_DOCUMENT_FAILED"